"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _grid = require("@rebass/grid");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Body = _interopRequireDefault(require("../primitive/Body"));
var _excluded = ["options", "name", "active", "setActive"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ToggleSwitchWithText = function ToggleSwitchWithText(_ref) {
  var options = _ref.options,
    name = _ref.name,
    active = _ref.active,
    setActive = _ref.setActive,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var firstOption = options[0];
  var secondOption = options[1];
  var _useState = (0, _react.useState)((0, _toConsumableArray2["default"])(Array(12)).map(function () {
      return Math.floor(Math.random() * 16).toString(16);
    }).join('')),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    idSuffix = _useState2[0];
  return /*#__PURE__*/_react["default"].createElement(ToggleSwitch, props, /*#__PURE__*/_react["default"].createElement(_grid.Box, {
    p: 2
  }, /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(RadioButton, {
    type: "radio",
    value: firstOption.key,
    name: name,
    id: firstOption.key + idSuffix,
    checked: firstOption.key === active,
    onChange: function onChange() {
      return setActive(firstOption.key);
    }
  }), /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: firstOption.key + idSuffix
  }, /*#__PURE__*/_react["default"].createElement(StyledBody, {
    variant: "small"
  }, firstOption.label))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(RadioButton, {
    type: "radio",
    value: secondOption.key,
    name: name,
    id: secondOption.key + idSuffix,
    checked: secondOption.key === active,
    onChange: function onChange() {
      setActive(secondOption.key);
    }
  }), /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: secondOption.key + idSuffix
  }, /*#__PURE__*/_react["default"].createElement(StyledBody, {
    variant: "small"
  }, secondOption.label))))));
};
var _default = exports["default"] = ToggleSwitchWithText;
var ToggleSwitch = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitchWithText__ToggleSwitch",
  componentId: "sc-9k2i35-0"
})(["background-color:", ";border-radius:10rem;border:1px solid ", ";display:inline-block;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.neutral[5];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.neutral[20];
});
var RadioButton = _styledComponents["default"].input.withConfig({
  displayName: "ToggleSwitchWithText__RadioButton",
  componentId: "sc-9k2i35-1"
})(["display:none;cursor:pointer;+ label p{border:1px solid transparent;}&:checked + label p{transition:all 0.2s ease-in-out;background-color:", ";border:1px solid ", ";box-shadow:0 4px 8px -2px rgba(16,24,40,0.1),0px 2px 4px -2px rgba(16,24,40,0.06);}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.neutral[0];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.neutral[40];
});
var StyledBody = (0, _styledComponents["default"])(_Body["default"]).withConfig({
  displayName: "ToggleSwitchWithText__StyledBody",
  componentId: "sc-9k2i35-2"
})(["border-radius:10rem;padding:0.8rem 2.4rem;font-weight:600;@media screen and (min-width:", "px){padding:0.8rem 1.8rem;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQueriesValues.s;
});
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitchWithText__Wrapper",
  componentId: "sc-9k2i35-3"
})(["display:flex;"]);
var Label = _styledComponents["default"].label.withConfig({
  displayName: "ToggleSwitchWithText__Label",
  componentId: "sc-9k2i35-4"
})(["margin-bottom:0;&:hover{cursor:pointer;}"]);
//# sourceMappingURL=ToggleSwitchWithText.js.map